import React, { Component } from 'react';
import Notifications from '../Notifications';
import Polls from '../Polls';
import Surveys from '../Surveys';
import styled from 'styled-components';
import ErrorBoundary from '../Response/ErrorBoundary';
import { T } from '../Response/Utils';
const ChatNotifications = styled.div`
  .card-msg {
    color: ${(props: any) => {
      return props.foreground + 'cc';
    }};
  }

  .empty-notifications {
    width: fit-content;
    padding: 8px 24px;
    border-radius: 24px;
    border: solid 1px
      ${(props: any) => {
        return props.background + '33';
      }};
    background-color: ${(props: any) => {
      return props.foreground + 'cc';
    }};
    color: ${(props: any) => {
      return props.background;
    }};
    margin: 0 auto;
  }
`;
const styleVars = getComputedStyle(document.querySelector(':root'));

interface Props {
  toggleOverlay;
  isOverlayVisible: boolean;
  data;
  notifications;
  closeNotification;
  polls;
  pollSubmit;
  surveys;
  surveySubmit;
  langCode: string;
}

class ChatOverlay extends Component<Props, null> {
  // trackBannerOutboundLink(ev) {
  //   // console.log(ev);
  // }

  //Everething was well slow
  // Just use react profiler before/after commenting the below block
  // Please use botID = 136 (@ prod) for better comparisions
  shouldComponentUpdate(nextProps) {
    // debugger;
    if (
      nextProps.isOverlayVisible != this.props.isOverlayVisible ||
      nextProps.notifications != this.props.notifications ||
      nextProps.polls != this.props.polls ||
      nextProps.surveys != this.props.surveys
    ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    return (
      <ChatNotifications
        id={'sfOffersRoll'}
        className={`sf-offers-roll styled-scroll`}
        {...{
          background:
            styleVars.getPropertyValue('--srvMsgBackground') || '#383ff6',
          foreground: styleVars.getPropertyValue('--srvMsgColor') || '#ffffff'
        }}
        style={{
          display: this.props.isOverlayVisible ? 'block' : 'none'
        }}
      >
        <div className="sf-offers-pane body-text-2">
          {(!this.props.notifications ||
            this.props.notifications.length === 0) &&
          (!this.props.polls || this.props.polls.length === 0) &&
          (!this.props.surveys || this.props.surveys.length === 0) ? (
            <div className="empty-notifications caption-text">
              <T labelName="noNotificationLabel" />
            </div>
          ) : null}
          <ErrorBoundary langCode={this.props.langCode}>
            <Notifications
              notifications={this.props.notifications}
              closeNotification={this.props.closeNotification}
              toggleOverlay={this.props.toggleOverlay}
              langCode={this.props.langCode}
            />
          </ErrorBoundary>
          <ErrorBoundary langCode={this.props.langCode}>
            {this.props.polls &&
              this.props.polls.map((e, i) => {
                return (
                  <Polls
                    polls={e}
                    key={i}
                    pollSubmit={this.props.pollSubmit}
                    langCode={this.props.langCode}
                  />
                );
              })}
          </ErrorBoundary>
          <ErrorBoundary langCode={this.props.langCode}>
            {this.props.surveys &&
              this.props.surveys.map((e, i) => {
                return (
                  <Surveys
                    surveySubmit={this.props.surveySubmit.bind(this)}
                    surveys={e}
                    key={i}
                  />
                );
              })}
          </ErrorBoundary>
        </div>
      </ChatNotifications>
    );
  }
}

export default ChatOverlay;
